import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import useManageSku from '../sku/useManageSku';
import { formatAmount } from '../../../utils/formatAmount';
import { toast } from 'react-toastify';
import useManageStock from './useManageStock';
import { format } from 'date-fns';
import ExportWithMonthSelect from '../../../utils/ExportWithMonthSelect';
import moment from 'moment-timezone';
import { useManageExport } from '../export/useManageExport';

const AddStock = () => {

  const { getSkus } = useManageSku();
  const { addStockData } = useManageStock();
  const { exportStockIn } = useManageExport();

  const [date, setDate] = useState(null);
  const [amount, setAmount] = useState('');
  const [billNo, setBillNo] = useState('');
  const [rows, setRows] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [month, setMonth] = useState(moment().format('YYYY-MM'));

  const calculateGrandTotal = () => {
    return rows.reduce((total, row) => total + row.total, 0);
  };

  useEffect(() => {
    if (rows.length > 0) {
      const grandTotal = calculateGrandTotal();
      setGrandTotal(grandTotal);
    }
  }, [rows]);

  const handleQtyChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].qty = value;
    newRows[index].total = newRows[index].unitPrice * value;
    setRows(newRows);
  };

  const handleUnitPriceChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].unitPrice = value;
    newRows[index].total = newRows[index].unitPrice * newRows[index].qty;
    setRows(newRows);
  };

  const handleSubmitClick = async () => {

    const amountWithoutTax = parseFloat(amount / 1.07);
    if (isNaN(amount) || amount === '' || Math.abs(amountWithoutTax - grandTotal) >= 0.1) {
      toast.error("Grand total does not match the amount.");
      return;
    }
    console.log("IT PASS")
    const response = await addStockData({shipDate:format(date, 'yyyy-MM-dd'), referenceDoc: billNo, items:rows})
    if(response === true){
      toast.success("Add Stock Data successfully")
      resetState()
    }else{
      toast.error("Add Stock Data Failed")
    }
  }

  const handleActionClick = (qty, unitPrice, index) => {
    console.log(qty, unitPrice)
    const otherPrice = grandTotal - (qty * unitPrice);
    console.log(otherPrice)
    const newUnitPrice = Math.round((amount/1.07 - otherPrice)/qty*100)/100;
    console.log(newUnitPrice)
    const updatedRows = [...rows];
    updatedRows[index].unitPrice = newUnitPrice;
    updatedRows[index].total = updatedRows[index].qty * updatedRows[index].unitPrice;
    console.log(updatedRows)
    setRows(updatedRows);
  }

  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleAddStockClick = async () => {
    if (!date || isNaN(date.getTime())) {
      toast.error("Please provide a valid date.");
      return;
    }
  
    if (isNaN(amount) || amount === '') {
      toast.error("Please provide a valid amount.");
      return;
    }
  
    try {
      const response = await getSkus(); // Ensure backend sends randomConsumption
      const updatedRows = response.map((item) => {
        return {
          ...item,
          qty: 0,    
          total: 0,
        };
      });
      setRows(updatedRows);
      setIsDisabled(true); // Disable fields after successful submission
    } catch (error) {
      console.error('Error fetching SKUs:', error);
    }
  };  

  const handleExport = async () => {
    const response = await exportStockIn({month});
    if(response === true){
      toast.success("Export successful!");
    }else{
      toast.error(response);
    }
  };

  const resetState = () => {
    setRows([]);
    setAmount('');
    setBillNo('');
    setDate(null);
    setIsDisabled(false);
  }

  return (
    <div className="p-6">
      <div className='flex justify-between'>
        <h2>Stock จัดซื้อ</h2>
        <ExportWithMonthSelect 
          month={month}
          handleMonthChange={handleMonthChange}
          handleExport={handleExport}
        />
      </div>
      <div className="flex justify-between">
        <div className='flex space-x-4'>
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Stock In Date"
                value={date}
                onChange={(newDate) => setDate(newDate)}
                disabled={isDisabled}
                />
            </LocalizationProvider>
          </div>
          <div>
            <TextField
              label="Amount"
              variant="outlined"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              disabled={isDisabled}
              />
          </div>
          <div>
            <TextField
              label="Bill No."
              variant="outlined"
              value={billNo}
              onChange={(e) => setBillNo(e.target.value)}
              disabled={isDisabled}
              />
          </div>
          <Button variant="contained" color="primary" className="mt-4" onClick={handleAddStockClick}>
            Add Stock
          </Button>
        </div>
        <div className='space-x-4'>
          <TextField
            label="No Vat Amount"
            variant="outlined"
            value={formatAmount(amount/1.07)}
            readOnly={true}
          />
          <TextField
            label="Grand Total"
            variant="outlined"
            value={formatAmount(grandTotal)}
            readOnly={true}
          />
        </div>
      </div>

      {/* Line to Split Section */}
      <hr className="my-6 border-gray-300" />

      {/* Lower Section - Table */}
      {rows.length > 0 && <><div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 text-left">Code</th>
              <th className="py-2 px-4 text-left">Item</th>
              <th className="py-2 px-4 text-left">Unit Price</th>
              <th className="py-2 px-4 text-left">Qty</th>
              <th className="py-2 px-4 text-left">Total</th>
              <th className="py-2 px-4 text-left">Current Stock</th>
              <th className="py-2 px-4 text-left">7 Day Sold</th>
              <th className="py-2 px-4 text-left">Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td className="py-2 px-4 border">{row.skuCode}</td>
                <td className="py-2 px-4 border">{row.productName}</td>
                <td className="py-2 px-4 border">
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={row.unitPrice}
                    onChange={(e) => handleUnitPriceChange(index, e.target.value)}
                    fullWidth
                  />
                </td>
                <td className="py-2 px-4 border">
                  <TextField
                    variant="outlined"
                    size="small"
                    type="number"
                    value={row.qty}
                    onChange={(e) => handleQtyChange(index, e.target.value)}
                    fullWidth
                  />
                </td>
                <td className="py-2 px-4 border">{formatAmount(row.total)}</td>
                <td className="py-2 px-4 border">{formatAmount(row.currentStock)}</td>
                <td className="py-2 px-4 border">{formatAmount(row.sevenDayConsumption)}</td>
                <td className="py-2 px-4 border">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleActionClick(row.qty, row.unitPrice, index)} 
                  >
                    Adjust
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Submit Button */}
      <div className="mt-6">
        <Button variant="contained" color="primary" onClick={handleSubmitClick}>
          Submit
        </Button>
      </div>
      </>}
    </div>
  );
};

export default AddStock;
